import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./EditFederalTaxPage.css";

const EditFederalTaxPage = () => {
    const { id: businessId } = useParams();
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchFederalTaxData = async () => {
            try {
                const response = await api.get(`/tax-info/edit-federal/${businessId}`);
                setFormData(response.data || {});
            } catch (err) {
                console.error("Error fetching federal tax information:", err);
                setError("Failed to fetch federal tax information.");
            } finally {
                setLoading(false);
            }
        };

        fetchFederalTaxData();
    }, [businessId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.put(`/tax-info/edit-federal/${businessId}`, formData);
            console.log("Federal tax information updated successfully!");
            navigate(-1);
        } catch (err) {
            console.error("Error updating federal tax information:", err);
            alert("Failed to update federal tax information.");
        }
    };

    if (loading) return <p>Loading federal tax information...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="fed-tax-edit-page">
            <h4>Edit Federal Tax Information</h4>
            <form onSubmit={handleSubmit} className="fed-edit-form">
                <label>
                    Federal ID:
                    <input type="text" name="federal_id" value={formData.federal_id || ""} onChange={handleChange} />
                </label>
                <label>
                    Filing Frequency:
                    <select name="filing_frequency" value={formData.filing_frequency || ""} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Annually">Annually</option>
                        <option value="Household">Household</option>
                    </select>
                </label>
                <label>
                    Unemployment Exempt:
                    <select name="unemployment_exempt" value={formData.unemployment_exempt || ""} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </label>
                <button type="submit">Save Changes</button>
            </form>
        </div>
    );
};

export default EditFederalTaxPage;
